/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OdChargeIdEnum } from './odChargeIdEnum';


export interface MetricInfoPatchSpec { 
    internal_charge_id?: string;
    metric_uom?: string;
    od_charge_id?: OdChargeIdEnum;
}
export namespace MetricInfoPatchSpec {
}


